/**
 * Поле срока с быстрыми пресетами.
 *
 * До этого срок нельзя было задать вообще: колонка due_at в модели
 * есть, API её принимает, а поля в форме создания не было — задача
 * заводилась всегда без срока, и календарь показывать было нечего.
 *
 * Пресеты приходят пропом, а не импортом из домена: пакет ui
 * остаётся презентационным.
 */
export function DueField({
  value,
  onChange,
  presets = [],
  toInputValue,
  fromInputValue,
  label = 'Срок выполнения',
  hint = 'Задача попадёт в календарь на этот день',
  id = 'task-due',
}) {
  const inputValue = toInputValue ? toInputValue(value) : value || ''

  const applyPreset = (preset) => {
    const at = preset.at()
    onChange(fromInputValue ? at.toISOString() : at)
  }

  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label}
      </label>

      <div className="due-field__row">
        <input
          id={id}
          className="input"
          type="datetime-local"
          value={inputValue}
          onChange={(e) =>
            onChange(fromInputValue ? fromInputValue(e.target.value) : e.target.value)
          }
        />
        {value && (
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => onChange(null)}
          >
            Убрать
          </button>
        )}
      </div>

      {presets.length > 0 && (
        <div className="due-presets">
          {presets.map((p) => (
            <button
              key={p.key}
              type="button"
              className="chip"
              onClick={() => applyPreset(p)}
            >
              {p.label}
            </button>
          ))}
        </div>
      )}

      {hint && <span className="field__hint">{hint}</span>}
    </div>
  )
}
